import { Plural } from "@lingui/macro";
import { ApiEpBilling, IApiEpBillingProduct } from "@smp/api";
import { UiBox, UiGrid } from "@smp/ui";
import { testAppendAttr } from "@smp/utils";
import { useState } from "react";
import { useQuery } from "react-query";

import { BlockTryPro } from "@/components/blocks/block_try_pro";
import { useEpBillingFeatureList } from "@/hooks/use_ep_billing_feature";

import { DialogPurchase } from "../../dialog_purchase";
import { UiProduct } from "../../shared/ui_product";

export const Video = ({
  onClose,
  onClickTryPro,
}: {
  onClose: () => void;
  onClickTryPro?: () => void;
}) => {
  const [product, setProduct] = useState<IApiEpBillingProduct | undefined>(
    undefined,
  );
  const { featureList } = useEpBillingFeatureList();

  const featureVideo = featureList?.find(
    (feature) => feature.name === "video_posting",
  );

  const { data: productFeatureSubscriptions } = useQuery(
    [
      "ep.billing.product.feature_subscription",
      { query: { is_single_payment_allowed: true } },
    ],
    () =>
      ApiEpBilling.Product.FeatureSubscription.list({
        query: { is_single_payment_allowed: true },
      }),
  );

  const productFeatureSubscriptionsVideo = productFeatureSubscriptions?.filter(
    (productFeatureSubscription) =>
      productFeatureSubscription.feature === featureVideo?.id,
  );

  const handleClose = () => {
    setProduct(undefined);
    onClose();
  };

  const handleProductChange = (product: IApiEpBillingProduct) => {
    setProduct(product);
  };

  if (!productFeatureSubscriptionsVideo) {
    return null;
  }

  return (
    <>
      <UiBox>
        <UiGrid container spacing={2}>
          {productFeatureSubscriptionsVideo
            .sort((a, b) => {
              if (a.period_days > b.period_days) return 1;
              if (a.period_days < b.period_days) return -1;
              return 0;
            })
            .map((productFeatureSubscriptionVideo) => (
              <UiGrid
                item
                key={productFeatureSubscriptionVideo.id}
                xs={6}
                sm={4}
              >
                <UiProduct
                  {...testAppendAttr(
                    "id",
                    `buy_video_${productFeatureSubscriptionVideo.period_days}`,
                  )}
                  fullWidth
                  key={productFeatureSubscriptionVideo.id}
                  name={
                    <Plural
                      zero={`days`}
                      one={`day`}
                      few={`days`}
                      many={`days`}
                      other={`days`}
                      value={productFeatureSubscriptionVideo.period_days}
                    />
                  }
                  onClick={handleProductChange}
                  product={productFeatureSubscriptionVideo}
                />
              </UiGrid>
            ))}
          <UiGrid item xs={12}>
            <BlockTryPro
              additionalAction={() => {
                onClose();
                onClickTryPro && onClickTryPro();
              }}
            />
          </UiGrid>
        </UiGrid>
      </UiBox>
      {!!product && (
        <DialogPurchase
          onClose={handleClose}
          open={!!product}
          product={product}
        />
      )}
    </>
  );
};
